import * as React from "react";
import PropTypes from "prop-types";
import { Icon as PLIcon } from "@lululemon/ui-library";
import {
  antiAbrasionIcon,
  antiStinkIcon,
  breathableIcon,
  cozyIcon,
  genericFabricIcon,
  lightweightIcon,
  softIcon,
  stretchyIcon,
  warmthIcon,
  waterClaimsIcon,
  wickingIcon,
  abcIcon,
  genericFeaturesIcon,
  pocketsIcon,
  reversibleIcon,
  ventingIcon,
  linerIcon,
  reflectiveIcon,
  coldWashIcon,
  productCareDoNotBleachIcon,
  productCareDoNotDryCleanIcon,
  productCareDoNotIronIconIcon,
  productCareDoNotTumbleDryIcon,
  doNotUseFabricSoftnersIcon,
  productCareDoNotWashIcon,
  productCareDryCleanMildCycleIcon,
  productCareDryCleanOnlyIcon,
  productCareLayFlatToDryIcon,
  gentleCycle30DegreeWashIcon,
  productCareTumbleDryLowIcon,
  goodCashmereStandardIcon,
  productCareHandWashColdIcon,
  ironLowIcon,
  productCareLineDryIcon,
  productCareMachineWashColdIcon,
  permanentPressCycleTumbleDryLowIcon,
  productCareMachineWashWarmIcon,
  membershipIcon,
  productCareOnlyNonChlorineBleachIcon,
  permanentPressCycle30DegreesMachineWashIcon,
  playIcon,
  responsibleDownStandardIcon,
  productCareTumbleDryMediumIcon,
  tumbleDryWarmIcon,
  washProductSeparateIcon,
  washProductInsideOutIcon,
  adjustableIcon,
  everydayIcon,
  riseIcon,
  runIcon,
  silhouetteIcon,
  sizeIcon,
  supportIcon,
  sweatIcon,
  trainIcon,
  classesIcon,
  tagIcon
} from "@lululemon/ui-icons";

const map = {
  fabric_antiabrasion: antiAbrasionIcon,
  fabric_antistink: antiStinkIcon,
  fabric_breathable: breathableIcon,
  fabric_cozy: cozyIcon,
  fabric_generic: genericFabricIcon,
  fabric_lightweight: lightweightIcon,
  fabric_soft: softIcon,
  fabric_stretchy: stretchyIcon,
  fabric_warmth: warmthIcon,
  fabric_waterclaims: waterClaimsIcon,
  fabric_wicking: wickingIcon,
  feature_abc: abcIcon,
  feature_generic: genericFeaturesIcon,
  feature_pockets: pocketsIcon,
  feature_reversible: reversibleIcon,
  feature_venting: ventingIcon,
  feature_liner: linerIcon,
  feature_reflective: reflectiveIcon,
  "icon-cold-wash": coldWashIcon,
  "icon-do-not-bleach": productCareDoNotBleachIcon,
  "icon-do-not-dry-clean": productCareDoNotDryCleanIcon,
  "icon-do-not-iron": productCareDoNotIronIconIcon,
  "icon-do-not-tumble-dry": productCareDoNotTumbleDryIcon,
  "icon-do-not-use-fabric-softners": doNotUseFabricSoftnersIcon,
  "icon-do-not-wash": productCareDoNotWashIcon,
  "icon-dry-clean-mild-cycle": productCareDryCleanMildCycleIcon,
  "icon-dry-clean-only": productCareDryCleanOnlyIcon,
  "icon-dry-flat": productCareLayFlatToDryIcon,
  "icon-gentle-cycle-30-degree-wash": gentleCycle30DegreeWashIcon,
  "icon-gentle-cycle-tumble-dry-low": productCareTumbleDryLowIcon,
  "icon-good-cashmere-standard": goodCashmereStandardIcon,
  "icon-hand-wash": productCareHandWashColdIcon,
  "icon-iron-low": ironLowIcon,
  "icon-line-dry-hang-to-dry": productCareLineDryIcon,
  "icon-machine-wash-cold": productCareMachineWashColdIcon,
  "icon-machine-wash-warm": productCareMachineWashWarmIcon,
  "icon-membership": membershipIcon,
  "icon-only-non-chlorine-bleach": productCareOnlyNonChlorineBleachIcon,
  "icon-permanent-press-cycle-30-degrees-machine-wash":
    permanentPressCycle30DegreesMachineWashIcon,
  "icon-permanent-press-cycle-tumble-dry-low":
    permanentPressCycleTumbleDryLowIcon,
  "icon-play": playIcon,
  "icon-responsible-down-standard": responsibleDownStandardIcon,
  "icon-tumble-dry-medium": productCareTumbleDryMediumIcon,
  "icon-tumble-dry-warm": tumbleDryWarmIcon,
  "icon-wash-product-seperate": washProductSeparateIcon,
  "icon-wash-products-inside-out": washProductInsideOutIcon,
  icon_adjustable: adjustableIcon,
  icon_everyday: everydayIcon,
  icon_rise: riseIcon,
  icon_run: runIcon,
  icon_silhouette: silhouetteIcon,
  icon_size_default: sizeIcon,
  icon_support: supportIcon,
  icon_sweat: sweatIcon,
  icon_train: trainIcon,
  icon_yoga: classesIcon,
  "shop-the-look": tagIcon
};

const overwriteIconName = {
  features_liner: "feature_liner",
  features_reflective: "feature_reflective",
  feature_adjustible: "icon_adjustable"
};

const IconByName = ({ name, className }) => {
  const iconName = overwriteIconName[name] || name;

  if (!iconName || iconName === "") return null;

  const content = map[iconName];

  if (!content) {
    return null;
  }

  return <PLIcon content={content} className={className} />;
};

IconByName.propTypes = {
  name: PropTypes.oneOf([
    ...Object.keys(map),
    "feature_adjustible",
    "features_reflective",
    "features_liner",
    ""
  ]).isRequired,
  className: PropTypes.string
};

export default IconByName;
